import { render, staticRenderFns } from "./Typecertification.vue?vue&type=template&id=92371f80"
import script from "./Typecertification.vue?vue&type=script&lang=js"
export * from "./Typecertification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports